import { memo, useCallback, useMemo } from 'react';
import { Text, Switch, Button, Icon, Menus, useTheme } from '@Sage/hoi-poi-ui';
import { getLiteral } from 'utils/getLiteral';

const AutomationBuilderToolbar = memo(({ enabled, onChange, onEditDetails }) => {
    const theme = useTheme();
    const showSupportChat = Boolean(window.Intercom);
    const onChangeEnabled = useCallback(
        (value) => {
            onChange('enabled', value);
        },
        [onChange],
    );

    const learnMoreMenu = useMemo(() => {
        const learnMoreItems = [
            {
                title: getLiteral('action_automations_knowledge_base'),
                icon: <Icon name="document" />,
                onClick: () => {
                    window.open(getLiteral('label_automations_knowledge_base_link'), '_blank');
                },
            },
        ];

        return (
            <Menus
                title={
                    <Button type="terciary" size="small" icon="infoOutlined">
                        {getLiteral('label_learn_more')}
                    </Button>
                }
                classNameMenu="fm-automation-builder__toolbar-helpers-menu"
                items={learnMoreItems}
            />
        );
    }, []);

    let openIntercom = null;
    if (showSupportChat) {
        openIntercom = (
            <Button
                type="terciary"
                size="small"
                icon="comment"
                onClick={() => {
                    window.Intercom('showNewMessage');
                }}
            >
                {getLiteral('action_support_chat')}
            </Button>
        );
    }

    return (
        <div className="fm-automation-builder__toolbar">
            <div className="fm-automation-builders__toolbar-items">
                <div className="fm-automation-builder__toolbar-item">
                    <Button
                        size="small"
                        icon="settings"
                        type="terciary"
                        onClick={() => onEditDetails()}
                    >
                        {getLiteral('label_automation_edit_name')}
                    </Button>
                </div>
                <Icon name="verticalDivider" color={theme.colors.grey[100]} />
                <div className="fm-automation-builder__toolbar-item">
                    <Text>{getLiteral('label_active')}</Text>
                    <Switch size="medium" onChange={onChangeEnabled} checked={enabled} />
                </div>
            </div>
            <div className="fm-automation-builder__toolbar-helpers">
                {learnMoreMenu}
                {openIntercom}
            </div>
        </div>
    );
});

export default AutomationBuilderToolbar;
